import { render } from "./Footer.vue?vue&type=template&id=5f13a021&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5f13a021&scoped=true&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f13a021"]])

export default __exports__